<template>
  <div>
    <HeaderTabs
      :show-breadcrumbs="true"
      :tabs-list="projectTabs"
    />
    <SpinnerContainer
      v-if="appLoading"
      :is-loading="appLoading"
      class="nested-tab-page-spinner"
    />
    <router-view />
  </div>
</template>

<script>
  import HeaderTabs from 'components/common/HeaderTabs/HeaderTabs';
  import translation from 'translation';
  import {mapGetters} from 'vuex';
  import {SpinnerContainer} from '@marilyn/marilyn-ui';

  function getChannelsIconsList (channels) {
    return channels.filter(c => c.is_enabled).map(item => item.icon).
      filter(item => Boolean(item));
  }

  export default {
    name: 'ProjectNestedPage',
    components: {HeaderTabs, SpinnerContainer},
    computed: {
      ...mapGetters('accounts', ['currentAccount', 'hasComponent']),
      ...mapGetters('channels', [
        'balancingChannels',
        'bidmanagerChannels',
        'linkCheckingChannels',
        'crossminusChannels',
        'generationChannels',
        'utmTaggerChannels',
        'segmentsChannels'
      ]),
      ...mapGetters('common', ['appLoading']),
      ...mapGetters('projects', ['currentProject']),
      balancingChannelIcons () {
        return getChannelsIconsList(this.balancingChannels);
      },
      bidmanagerChannelIcons () {
        return getChannelsIconsList(this.bidmanagerChannels);
      },
      linkCheckingChannelIcons () {
        return getChannelsIconsList(this.linkCheckingChannels);
      },
      crossminusChannelIcons () {
        return getChannelsIconsList(this.crossminusChannels);
      },
      generationChannelIcons () {
        return getChannelsIconsList(this.generationChannels);
      },
      utmTaggerChannelIcons () {
        return getChannelsIconsList(this.utmTaggerChannels);
      },
      segmentsChannelIcons () {
        return getChannelsIconsList(this.segmentsChannels);
      },
      projectTabs () {
        if (!this.currentAccount || !this.currentProject) {
          return [];
        }
        return [
          {
            id: 'details',
            title: translation.tr('Details'),
            to: {
              name: 'projectDetails',
              params: {
                accountId: this.currentAccount.id,
                projectId: this.currentProject.id
              }
            },
            exactMatch: true
          },
          {
            id: 'orders',
            title: translation.tr('Orders'),
            to: {name: 'ordersList'}
          },
          {
            id: 'placements',
            title: translation.tr('Placements'),
            to: {name: 'placementsList'}
          },
          this.currentProject.is_fine_tuned ? {
            id: 'booking',
            title: translation.tr('Booking'),
            to: {name: 'booking'}
          } : [],
          {
            id: 'statistics',
            title: translation.tr('Statistics'),
            to: {name: 'projectStatistics'}
          },
          {
            id: 'reports',
            title: translation.tr('Reports'),
            to: {name: 'reportsList'}
          },
          {
            id: 'projectHistory',
            title: translation.tr('History'),
            to: {name: 'projectHistory'}
          },
          {
            id: 'markupRates',
            title: translation.tr('Markups'),
            to: {name: 'markupRatesList'}
          },
          {
            id: 'settings',
            title: translation.tr('Settings'),
            to: {name: 'projectSettings'},
            forceRouteTitles: {

              // disable header, because profile view has header
              webAnalyticsProfileDetails: ''
            }
          },
          {
            id: 'tools',
            title: translation.tr('Tools'),
            popperClass: 'project-tools__menu',
            items: [
              {
                id: 'balancing',
                title: translation.tr('Daily budget balancing'),
                to: {name: 'projectBalancing'},
                icons: this.balancingChannelIcons
              },
              {
                id: 'bidmanager',
                title: translation.tr('Bid Manager'),
                to: {name: 'projectBidManager'},
                icons: this.bidmanagerChannelIcons
              },
              {
                id: 'syncGroups',
                title: translation.tr('Sync with sources'),
                to: {name: 'syncGroupsList'}
              },
              {
                id: 'urlCheck',
                title: translation.tr('Link checking'),
                to: {name: 'urlcheck'},
                icons: this.linkCheckingChannelIcons
              },
              {
                id: 'crossminus',
                title: translation.tr('Crossminusing'),
                to: {name: 'crossminus'},
                icons: this.crossminusChannelIcons
              },
              {
                id: 'generation',
                title: translation.tr('Ad generation'),
                to: {name: 'generation'},
                icons: this.generationChannelIcons
              },
              {
                id: 'utmTagger',
                title: translation.tr('UTM-tagger'),
                to: {name: 'placementTaggingGroupsList'},
                icons: this.utmTaggerChannelIcons
              },
              {
                id: 'segments',
                title: translation.tr('Audience segments'),
                to: {name: 'segments'},
                icons: this.segmentsChannelIcons
              }
            ]
          }
        ].filter(t => Boolean(t));
      }
    }
  };
</script>
